import './App.css';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Content from './components/layout/Content';
import About from './components/pages/About';
import Contact from './components/pages/Contact';
import Projects from './components/pages/Projects';
import Trainings from './components/pages/Trainings';
import PaymentSummary from './components/pages/PaymentSummary';
import Comment from './components/pages/Comment';
import OrderStatus from './components/pages/OrderStatus'; // Import the new OrderStatus component
import { BrowserRouter as Router, Route, Routes } from 'react-router';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Content>
          <Routes>
            <Route path="/" element={<About />} />
            <Route path="/about" element={<About />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/schedule" element={<Trainings />} />
            <Route path="/payment" element={<PaymentSummary />} />
            <Route path="/comment" element={<Comment />} />
            <Route path="/order-status/:orderId" element={<OrderStatus />} /> {/* Add the new route */}
          </Routes>
        </Content>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
